import { z } from 'zod';
import zxcvbn from 'zxcvbn';

/**
 * Score zxcvbn minimal d'un nouveau mot de passe, sur une échelle de 0 à 4.
 * C'est la règle qu'appliquaient déjà les deux écrans, en désactivant leur
 * bouton : elle est désormais écrite une seule fois.
 */
export const SCORE_MINIMAL = 4;

export const estAssezFort = (motDePasse) =>
  typeof motDePasse === 'string' && zxcvbn(motDePasse).score >= SCORE_MINIMAL;

const nouveauMotDePasse = z
  .string({ message: 'saisir_un_nouveau_mot_de_passe' })
  .min(1, { message: 'saisir_un_nouveau_mot_de_passe' })
  .refine(estAssezFort, { message: 'mot_de_passe_trop_faible' });

/**
 * La confirmation est comparée au moment de l'envoi. Les écrans calculaient
 * l'égalité à la frappe dans le seul champ de confirmation : modifier ensuite
 * le nouveau mot de passe laissait l'indicateur sur « identiques ».
 */
const confirmationIdentique = (valeurs, ctx) => {
  if (valeurs.confirmation !== valeurs.nouveau) {
    ctx.addIssue({
      code: 'custom',
      path: ['confirmation'],
      message: 'mots_de_passe_differents',
    });
  }
};

/** Réinitialisation par lien : nouveau mot de passe et confirmation. */
export const schemaReinitialisationMotDePasse = z
  .object({
    nouveau: nouveauMotDePasse,
    confirmation: z.string({ message: 'mots_de_passe_differents' }),
  })
  .superRefine(confirmationIdentique);

/** Changement depuis le profil : l'ancien mot de passe est exigé en plus. */
export const schemaChangementMotDePasse = z
  .object({
    ancien: z
      .string({ message: 'saisir_l_ancien_mot_de_passe' })
      .min(1, { message: 'saisir_l_ancien_mot_de_passe' }),
    nouveau: nouveauMotDePasse,
    confirmation: z.string({ message: 'mots_de_passe_differents' }),
  })
  .superRefine(confirmationIdentique);
